<template>
  <fragment>
    <md-table-row v-for="(row, index) in rows" :key="index">
      <md-table-cell colspan="2">{{
        moment(row.travel_date).format("YYYY-MM-DD")
      }}</md-table-cell>

      <!-- target-table-tuple is bind to API tuple -->
      <slot v-bind:row="row"></slot>
    </md-table-row>
  </fragment>
</template>

<script>
import moment from "moment";
import { Fragment } from "vue-fragment";

export default {
  name: "TargetTableDataPerDay",
  props: {
    rows: Array,
    filters: Object
  },
  components: {
    Fragment
  }
};
</script>
